import * as React from "react";

import { Text } from "@fluentui/react";

const rootStyle: React.CSSProperties = {
  margin: "4px 8px",
};

// Truncate the text if it's longer than a fixed max length, and
// append an ellipsis to it.
function truncate(text: string): string {
  const maxFilterTextLengthToDisplay = 30;

  if (text.length <= maxFilterTextLengthToDisplay) {
    return text;
  }

  return `${text.substr(0, maxFilterTextLengthToDisplay - 1)}…`;
}

export function defaultRenderEmptyContent(
  label: string | undefined,
  filterText: string | undefined
): React.ReactElement | null {
  if (!label) {
    return null;
  }

  if (!filterText) {
    return <Text>{label}</Text>;
  }

  const index = label.indexOf("{0}");
  if (index === -1) {
    return <Text>{label}</Text>;
  }

  const prefix = label.substr(0, index);
  const suffix = label.substr(index + 3);

  return (
    <div style={rootStyle}>
      <span>{prefix}</span>
      <strong>{truncate(filterText)}</strong>
      <span>{suffix}</span>
    </div>
  );
}
